module.exports = __webpack_public_path__ + "media/images/profile-pic-dd099bc073cf2dce7c0b87339c342423.png";